import BaseObject from '../../../base/base_object';
import {TimeSpan} from "@sparkware/app-utils";
import Event, {SystemEventSubscription} from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import ServiceFactory from '../../service_factory';
import {StartSessionTimerContext} from "../regulations/base_regulation";

interface GenericRealityCheckMessageHandlerParams {
    serviceFactory: ServiceFactory;
    handleRealityCheckMessageCallback: (TimeSpan, closedCallback?:Function) => void;
    realityCheckInterval: TimeSpan;
    context: StartSessionTimerContext
}

export default class GenericRealityCheckMessageHandler extends BaseObject {
    static CLASS = 'GenericRealityCheckMessageHandler';

    protected _initParams: GenericRealityCheckMessageHandlerParams;
    init(params: GenericRealityCheckMessageHandlerParams) {
        super.init(params);
        this._initParams = params;
        this._subscribe();

        if(this._initParams.context === StartSessionTimerContext.OnLogin) {
            this._onOAuthStateChange();
        }
    }

    private SESSION_TIMER_UPDATE_SUBSCRIPTION: SystemEventSubscription = null;
    private OAUTH_STATE_CHANGE_SUBSCRIPTION: SystemEventSubscription = null;
    private _subscribe(): void {
        this.SESSION_TIMER_UPDATE_SUBSCRIPTION = Event.on(SYSTEM_EVENTS.SESSION_TIMER_UPDATE, this._onSessionTimerUpdate.bind(this), this);
        this.OAUTH_STATE_CHANGE_SUBSCRIPTION = Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onOAuthStateChange.bind(this), this);
    }

    private _unsubscribe(): void {
        if (this.SESSION_TIMER_UPDATE_SUBSCRIPTION) {
            this.SESSION_TIMER_UPDATE_SUBSCRIPTION.off();
        }

        if(this.OAUTH_STATE_CHANGE_SUBSCRIPTION) {
            this.OAUTH_STATE_CHANGE_SUBSCRIPTION.off();
        }
    }

    dispose() {
        this._unsubscribe();
        this._lastRealityCheckMessageIndexShown = 0;
    }

    private _onOAuthStateChange(): void {
        let beforeValue = this._lastRealityCheckMessageIndexShown;
        this._lastRealityCheckMessageIndexShown = 0;
        this.logger.info('RealityCheck _onOAuthStateChange before and after set:'+beforeValue.toString() + " " + this._lastRealityCheckMessageIndexShown.toString());
    }

    private _inMem_lastRealityCheckMessageIndexShown = 0;

    protected set _lastRealityCheckMessageIndexShown(value) {
        this._inMem_lastRealityCheckMessageIndexShown = value
    }

    protected get _lastRealityCheckMessageIndexShown() {
        return this._inMem_lastRealityCheckMessageIndexShown;
    }

    protected _onSessionTimerUpdate(eventData: {sessionTime: TimeSpan}): void {
        if(!this._initParams.serviceFactory.oAuth2Service().isAuthorized()) {
            return;
        }

        let currentRealityCheckMessageIndexToBeShown = Math.floor(eventData.sessionTime.totalMilliseconds / this._initParams.realityCheckInterval.totalMilliseconds);

        if(this._lastRealityCheckMessageIndexShown < currentRealityCheckMessageIndexToBeShown) {
            this._initParams.handleRealityCheckMessageCallback(eventData.sessionTime);
            this._lastRealityCheckMessageIndexShown = currentRealityCheckMessageIndexToBeShown;
        }
    }
}